import { render, staticRenderFns } from "./ThreeOptionsListGeneral.vue?vue&type=template&id=81e2465e&scoped=true"
import script from "./ThreeOptionsListGeneral.vue?vue&type=script&lang=ts"
export * from "./ThreeOptionsListGeneral.vue?vue&type=script&lang=ts"
import style0 from "./ThreeOptionsListGeneral.vue?vue&type=style&index=0&id=81e2465e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e2465e",
  null
  
)

export default component.exports